let languageSelect = document.getElementsByClassName('language-select');

if (languageSelect.length === 1) {
    languageSelect = languageSelect[0];

    let languageSelectItems = languageSelect.getElementsByClassName('selects')[0];

    languageSelectItems.addEventListener('click', (e) => {
        // e.preventDefault();
        e.stopPropagation();
    });

    languageSelect.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        languageSelect.getElementsByClassName('selects')[0].classList.toggle('hidden');
    });
}
